export default "__VITE_ASSET__CApCbJ2V__"